import { SapiService } from '../../../services/sapi.service';
import { Component, Input, ViewChild, ElementRef, forwardRef, OnInit, OnDestroy } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { FilterConfig, FilterSet, FilterSetService } from '../../../services/filter-set.service';
import { Subscription } from 'rxjs';
import { BbFilterPreset } from '../bb-filters/bb-filters.component';
import { OverlayService } from '../../../services/overlay.service';

export interface PresetsFilterListOption {
	value: string;
	label: string;
	amount: number;
	selected?: boolean;
}

@Component({
	selector: 'bb-presets-filter-list',
	templateUrl: './bb-presets-filter-list.component.html',
	styleUrls: ['./bb-presets-filter-list.component.scss'],
	providers: [{
		provide: NG_VALUE_ACCESSOR,
		useExisting: forwardRef(() => BbPresetsFilterListComponent),
		multi: true
	}]
})

export class BbPresetsFilterListComponent implements ControlValueAccessor, OnInit, OnDestroy {

	@Input() fieldName: string;
	@Input() options: PresetsFilterListOption[];
	@Input() filterConfig: FilterConfig;
	@Input() filterSet: FilterSet;
	@Input() facetsLoading = false;
	@Input() allowCustomPreset: boolean;
	@Input() storedItems: string[] = [];
	@ViewChild('newPresetInput') newPresetInput: ElementRef;

	selected: any[];
	numResultsShown: number;
	propagateChange: any;
	values: string[] = [];
	editMode = false;
	filterSetChangedSubscription: Subscription;

	protected subscriptions = new Subscription();

	constructor(private overlayService: OverlayService,
		private filterSetService: FilterSetService,
		private sapiService: SapiService) {
		this.selected = [];
		this.numResultsShown = 15;
	}

	ngOnInit() {
		this.filterSet = this.filterSetService.getFilterSet();

		this.subscriptions.add(
			this.filterSetService.filterSetChangedObservable.subscribe(newFilterSet => {
				this.filterSet = newFilterSet;
			})
		);

		this.subscriptions.add(
			this.filterSetService.savePresetObservable.subscribe((customPreset) => {
				this.optionChecked(customPreset, true);
			})
		);

		if (!this.allowCustomPreset) {
			this.allowCustomPreset = false;
		}
	}

	optionChecked(preset: BbFilterPreset, checked: boolean) {
		const index = this.values.indexOf(preset.id || preset.value);

		for (let i = 0; i < this.storedItems.length; i++) {
			if (this.storedItems[i] === preset.id || this.storedItems[i] === preset.value) {
				this.storedItems.splice(i, 1);
			}
		}

		if (checked && index === -1) {
			this.values.push(preset.id || preset.value);
			this.storedItems.push(preset.id || preset.value);
		} else if (!checked && index > -1) {
			this.values.splice(index, 1);
		}

		if (typeof this.propagateChange !== 'undefined') {
			this.propagateChange(this.values);
		}

		this.sapiService.putUrl('/user/me/settings/presets', this.storedItems).subscribe(() => {
			this.overlayService.setLoading(false);
		});
	}

	writeValue(value: string[]) {
		this.values = (value ? value : []);
	}

	registerOnChange(fn: any) {
		this.propagateChange = fn;
	}

	registerOnTouched() {

	}

	ngOnDestroy() {
		this.subscriptions.unsubscribe();
	}

	enterPreset() {
		this.editMode = true;

		setTimeout(() => {
			if (this.newPresetInput) {
				this.newPresetInput.nativeElement.focus();
			}
		});
	}

	deletePreset(preset: BbFilterPreset) {
		this.filterSetService.deleteCustomPreset(preset);
	}

	onInputChanged(presetName: string) {
		this.filterSetService.saveCustomPreset(presetName);
		this.editMode = false;
	}
}
